import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  clearCurrentBroadcastMessage,
  fetchBroadcastMessage
} from '../../../modules/message';

import { authUtil } from '../../../utils';

import BroadcastMessage from './broadcastMessage';
import BroadcastMessageReport from './broadcastMessageReport';
import { PaddedWrapper } from '../../../style';

export class BroadcastMessageContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {activeTab: 'message'};
  }

  componentDidMount() {
    this.fetchBroadcastMessage();
  }

  componentWillUnmount() {
    this.props.clearCurrentBroadcastMessage();
  }

  fetchBroadcastMessage = async () => {
    const { match } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    const { messageId } = match.params;
    this.props.fetchBroadcastMessage({ idToken, messageId });
  }

  render() {
    const { t, currentBroadcastMessage } = this.props;
    if (!currentBroadcastMessage) return null;

    const {activeTab} = this.state;
    return (
      <PaddedWrapper>
        <div className="br-broadcast-tabs" role="tablist" aria-label={t('Message', 'Message')}
          onKeyDown={event => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const next = event.key === 'Home' ? 'message'
              : event.key === 'End' ? 'seen'
                : this.state.activeTab === 'message' ? 'seen' : 'message';
            this.setState({activeTab: next});
            event.currentTarget.querySelector(`#broadcast-tab-${next}`)?.focus();
          }}>
          <button type="button" role="tab" id="broadcast-tab-message"
            aria-selected={activeTab === 'message'} aria-controls="broadcast-panel-message"
            onClick={() => this.setState({activeTab: 'message'})}>
            {t('Message')}
          </button>
          <button type="button" role="tab" id="broadcast-tab-seen"
            aria-selected={activeTab === 'seen'} aria-controls="broadcast-panel-seen"
            onClick={() => this.setState({activeTab: 'seen'})}>
            {t('Seen')} ({currentBroadcastMessage.seenCount || 0})
          </button>
        </div>
        {activeTab === 'message'
          ? <section role="tabpanel" id="broadcast-panel-message" aria-labelledby="broadcast-tab-message">
              <BroadcastMessage message={currentBroadcastMessage} />
            </section>
          : <section role="tabpanel" id="broadcast-panel-seen" aria-labelledby="broadcast-tab-seen">
              <BroadcastMessageReport filter="seenAt" messageId={currentBroadcastMessage._id} />
            </section>}
      </PaddedWrapper>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  currentBroadcastMessage: state.message.currentBroadcastMessage,
  fetchingBroadcastMessage: state.message.fetchBroadcastMessage
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage),
  clearCurrentBroadcastMessage,
  fetchBroadcastMessage
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BroadcastMessageContainer)));
